








  import { Component, Vue } from 'vue-property-decorator';
import LogoutModel from '../src/components/LogoutModel.vue';
import { mapState } from "vuex";
import { store, StoreState } from "src/store";

@Component({
  components: {
    LogoutModel
  },
  computed: {
    ...mapState({
        'logout': (state: StoreState) =>  state.account.logout_status,
         'isIDLE': (state: StoreState) =>state.dashboard.isIDLE
    })
  }
 
})
  export default class App extends Vue {


 created() {
    this.$store.dispatch('getPrivilegeLevel');
     this.verifyToken(); 
    //alert('app')
   // this.inactivityTime();
    
   // this.timeout();
   }
  //relogin if token expires
   verifyToken()
   {  
     if(!(window.location.pathname=='/login')){
            this.$store.dispatch("verifyJWT")
            .then(r => {})
            .catch(() => {});
     }
     setTimeout(this.verifyToken, 1000*60*60*5)  ; 
   }

 timeout=function(){
  var self=this;
  setTimeout(function(){ 
     self.$store.commit('LOGOUT_STATUS' , true);  
  
    }, 1000*60*60*5);
 }  


 inactivityTime = function () {
  var time;
  var self=this;
  window.onload = resetTimer;
  window.onbeforeunload=resetTimer;
     
    // DOM Events
  document.onload = resetTimer;
  document.onmousemove = resetTimer;
  document.onmousedown = resetTimer; // touchscreen presses
  document.ontouchstart = resetTimer;
  document.onclick = resetTimer;     // touchpad clicks
  document.onscroll = resetTimer;    // scrolling with arrow keys
  document.onkeypress = resetTimer;  
    function logout() {
        
        if(!(window.location.pathname=='/login')){
         // alert("You are now logged out.")  ;
           clearTimeout(time);
            self.$store.commit('LOGOUT_STATUS' , true);  
        }
        else{
          self.$store.commit('LOGOUT_STATUS' , false);  
          resetTimer();
        }
    }
    function resetTimer() {
       // clearTimeout(time);
       time = setTimeout(logout, 1000*60*60*5); 
    }
   };
  }
